import { API_URL } from '../constants';
import fetchAuthorization from './fetchAuthorization';
import { getErrorMessage } from '../helpers';

export interface PlayerData {
  player_id: string;
}

export async function deletePlayer(data: PlayerData): Promise<any> {
  try {
    const response = await fetchAuthorization(`${API_URL}players?player_id=${data.player_id}`, {
      method: 'DELETE',
    });

    const result = await response.json();

    if (response.status !== 200) {
      const message = getErrorMessage(result);
      throw new Error(message ? message : `Status Code: ${response.status}. Sorry, something went wrong. Please try again later.`);
    }

    return result;
  } catch (e: any) {
    throw new Error(`We were unable to update player. Error message: ${e.message}`);
  }
}

export default deletePlayer;
